var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59 33H38c-1.924 0-4 1.529-4 4 0 2.543.547 4.319 1.075 6.036.476 1.545.925 3.003.925 4.964 0 1.173-.288 5-4 5s-4-3.827-4-5c0-1.961.449-3.419.925-4.964C29.453 41.319 30 39.543 30 37c0-2.471-2.076-4-4-4H5c-1.324 0-1.323 2 0 2h21c.83 0 2 .62 2 2 0 2.242-.479 3.8-.987 5.448C26.515 44.065 26 45.738 26 48c0 3.229 1.571 7 6 7s6-3.771 6-7c0-2.262-.515-3.935-1.013-5.552C36.479 40.8 36 39.242 36 37c0-1.38 1.17-2 2-2h21c1.324 0 1.323-2 0-2zM18 19c4.645 0 7 2.355 7 7 0 1.324 2 1.323 2 0 0-4.645 2.355-7 7-7 1.324 0 1.323-2 0-2-4.645 0-7-2.355-7-7 0-1.324-2-1.323-2 0 0 4.645-2.355 7-7 7-1.324 0-1.323 2 0 2zm8-4.246A7.141 7.141 0 0 0 29.246 18 7.141 7.141 0 0 0 26 21.246 7.141 7.141 0 0 0 22.754 18 7.136 7.136 0 0 0 26 14.754zM34 25c3.364 0 5 1.636 5 5 0 1.324 2 1.323 2 0 0-3.364 1.636-5 5-5 1.324 0 1.323-2 0-2-3.364 0-5-1.636-5-5 0-1.324-2-1.323-2 0 0 3.364-1.636 5-5 5-1.324 0-1.323 2 0 2zm6-2.898A5.517 5.517 0 0 0 41.898 24 5.517 5.517 0 0 0 40 25.898 5.517 5.517 0 0 0 38.102 24 5.526 5.526 0 0 0 40 22.102z",
    fill: "#7f56d9",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkin);
export default __webpack_public_path__ + "static/media/skin.ac90416a8ff39c3c22dc46b3ad2ce8a3.svg";
export { ForwardRef as ReactComponent };